// src/components/tiles/VariantPill.jsx
import React from 'react';
import { Chip } from '@mui/material';

export default function VariantPill({ variant }) {
  if (!variant) return null;

  const LABELS = {
    win: 'WIN',
    gap: 'GAP',
    positive: 'POSITIVE',
    negative: 'NEGATIVE',
    wishlist: 'WISH LIST',
    continue: 'CONTINUE',
    no_longer: 'NO LONGER',
    high: 'HIGH',
    medium: 'MEDIUM',
    low: 'LOW',
  };

  // style presets
  const sx = (() => {
    switch (variant) {
      case 'win':
        return { borderStyle: 'solid', borderColor: 'success.main' };
      case 'gap':
        return { borderStyle: 'dashed', borderColor: 'warning.main', backgroundColor: 'warning.50' };
      case 'positive':
        return { borderColor: 'success.light' };
      case 'negative':
        return { borderColor: 'warning.light' };
      case 'wishlist':
        return { borderColor: 'info.light' };
      case 'continue':
        return { borderColor: 'success.main' };
      case 'no_longer':
        return { borderColor: 'warning.main' };
      default:
        return {};
    }
  })();

  return (
    <Chip
      size="small"
      variant="outlined"
      label={LABELS[variant] || variant}
      sx={sx}
    />
  );
}
